import type { CompetitionsPageEndpointResponse } from '@ps/isp-web-services-types';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  competitionsRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  clear: (): State => ({ ...defaultState }),
  dataLoadSuccess: (_state: State, payload: CompetitionsPageEndpointResponse): State => ({
    ...payload,
    isLoading: false,
    errorCode: undefined,
    hasPreloaded: true
  }),
  dataLoadFailed: (state: State, payload: string): State => ({
    ...state,
    isLoading: false,
    errorCode: payload,
    hasPreloaded: true
  })
};
